import Vue from 'vue'

const globalEventBus = new Vue()

export default globalEventBus
